import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

import { CategoryType } from '@crema/models/Category';

export enum CATEGORY_MODE {
  NONE = 0,
  VIEW = 1,
  ADD_CAT = 2,
  ADD_SUB_CAT = 3,
}

export type CategoryState = {
  selectedCategory?: CategoryType;
  mode: CATEGORY_MODE;
  event?: { name: string; data?: CategoryType };
};

const initialState: CategoryState = {
  mode: CATEGORY_MODE.NONE,
};

export const categorySlice = createSlice({
  name: 'category',
  initialState,
  reducers: {
    setSelectedCategory: (state, action: PayloadAction<CategoryType | undefined>) => {
      // Redux Toolkit allows us to write "mutating" logic in reducers. It
      // doesn't actually mutate the state because it uses the Immer library,
      // which detects changes to a "draft state" and produces a brand new
      // immutable state based off those changes

      state.selectedCategory = action.payload;
    },
    setMode: (state, action: PayloadAction<CATEGORY_MODE>) => {
      state.mode = action.payload;
    },
    setEvent: (state, action: PayloadAction<{ name: string; data?: CategoryType } | undefined>) => {
      state.event = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setSelectedCategory, setMode, setEvent } = categorySlice.actions;

export default categorySlice.reducer;
